import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { AlertsService, CLToastType } from '@clavisco/alerts';

/**
 * AuthGuard is an Angular service that implements the CanActivate interface.
 * It is used to protect routes by checking if the user is authenticated.
 * If the user is not authenticated, they are redirected to the login page and shown an error message.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  /**
   * Constructor for AuthGuard.
   * @param authService - Service to handle authentication logic.
   * @param router - Angular Router for navigation.
   * @param alertService - Service to display alerts and notifications.
   */
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private alertService: AlertsService,
  ) {}

  /**
   * Determines whether a route can be activated based on the user's authentication status.
   * @param route - The activated route snapshot.
   * @param state - The router state snapshot.
   * @returns A boolean, UrlTree, Observable, or Promise indicating whether the route can be activated.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.IsAuthenticated()) {
      return true;
    } else {
      this.alertService.Toast({
        message: 'No tienes acceso a esta sección, para continuar por favor inicia sesión.',
        type: CLToastType.ERROR,
      });
      this.authService.Logout();
      const urlTree: UrlTree = this.router.createUrlTree(['/login'], {});
      this.router.navigateByUrl(urlTree);
      return false;
    }
  }
}
